import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useFindCEP({ token = '' }) {
  const mutation = useMutation({
    mutationKey: ['get-cep'],
    mutationFn: async (cep = '') => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/cep/${cep.replace(/\D/g, '')}`), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
